import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={19.735}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15600 20315"
    {...props}
  >
    <path
      d="m0 5916 15600 8c-97-1754-101-4485-804-5924L834 18 0 5916z"
      style={{
        fill: "#0f111c",
      }}
      className="fill"

    />
    <path
      d="m5624 6376 1474 6959 1333-18 1632-6906c-820 32-587-168-902 860l-1019 4258-327-5188c-573 748-259 3536-336 5178L6441 7297c-282-887-81-645-817-921z"
      style={{
        fill: "#191921",
      }}
      className="fill"

    />
    <path
      d="m4119 20315 7395-17-37-1477-7382-144z"
      style={{
        fill: "#11111d",
      }}
      className="fill"

    />
    <path
      d="M7442 17396c191 1013 103 515 373 793 277-305 197 141 375-783 88 1095 101 491 741 804-156-801-212-1938-650-2608l-931 2c-471 671-490 1598-672 2597 749-316 626 276 764-805z"
      style={{
        fill: "#13131f",
      }}
      className="fill"

    />
    <path
      d="M7141 15176h1350l28-1419-1439 1z"
      style={{
        fill: "#12111e",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
